import React, { useContext } from 'react';
import './TabNotificationRow.scss';
import { Appeal } from '../../model/Appeal';
import Constants from '../../constants/constants';
import TabNotificationRowModeration from './TabNotificationRoleRow/TabNotificationRowModeration';
import TabNotificationRowCoordinator from './TabNotificationRoleRow/TabNotificationRowCoordinator';
import TabNotificationRowExecutor from './TabNotificationRoleRow/TabNotificationRowExecutor';
import TabNotificationRowDirector from './TabNotificationRoleRow/TabNotificationRowDirector';
import { Context } from '../../index';

interface TabNotificationRoleRowProps {
  appeal: Appeal;
  handleAppealRemove: (appealId: number) => void;
}

const TabNotificationRoleRow = (
  props: TabNotificationRoleRowProps
): JSX.Element => {
  const { store } = useContext(Context);
  return (
    <>
      {store.hasRole(Constants.moderatorRole) && (
        <TabNotificationRowModeration
          appeal={props.appeal}
          handleAppealRemove={props.handleAppealRemove}
        />
      )}
      {store.hasRole(Constants.coordinatorRole) && (
        <TabNotificationRowCoordinator
          appeal={props.appeal}
          handleAppealRemove={props.handleAppealRemove}
        />
      )}
      {store.hasRole(Constants.executorRole) && (
        <TabNotificationRowExecutor appeal={props.appeal} />
      )}
      {store.hasRole(Constants.directorRole) && (
        <TabNotificationRowDirector appeal={props.appeal} />
      )}
    </>
  );
};

export default TabNotificationRoleRow;
